<template>
  <div class="px-3 pb-2">
    <h4 id="sidebar-orderdets-title" class="sidebar-title">YOUR<b>ORDER</b></h4>
    <b-list-group flush>
      <order-details
        v-for="orderline of orderlines"
        v-bind:orderline="orderline"
        v-bind:key="[orderline.item_id, orderline.choicestring, orderline.notes].join()"
        :sb_spinner="sb_spinner"
        @emit-adjust-line="emitAdjustOrderLine">
      </order-details>
    </b-list-group>
    <div class="mt-2 sb-info">
      <b-button variant="light" :disabled="sb_spinner" v-b-toggle.sidebar-orderdets>ADD SOMETHING ELSE</b-button>
    </div>
    <b-alert v-if="order_type==1" v-model="minDelAlert" variant="danger" class="mt-2 sb-alert" dismissible>Your order must total more than {{ defaultLocation.delivery_minimum | toCurrency }} for delivery</b-alert>
    <hr class="sb-line">
    <b-row>
      <b-col cols="8">Subtotal</b-col>
      <b-col class="orderdets-price">{{order_subtotal | toCurrency}}</b-col>
    </b-row>
    <div v-if="howtaken=='Phone'">
      <hr class="sb-line">
      <b-row>
        <b-col class="sb-info">
          Choose Tip:
          <b>
            <span v-if="tip_select!=-1">{{ tip_select }}%</span>
            <span v-else>{{ customTip | toCurrency }}</span>
          </b>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pl-2">
          <b-form-group>
            <b-form-radio-group
              id="tip-range"
              v-model="tip_select"
              :options="tipoptions"
              :disabled="sb_spinner"
              button-variant="outline-light"
              class="tip-buttons"
              buttons
              name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-collapse id="custom-tip-collapse" v-model="customTipVisible">
        <b-row>
          <b-col cols="3">Tip: $</b-col>
          <b-col>
            <b-form-input v-model="customTip" type="number" min="0.00" step="0.01" size="sm" :state="customTipState" class="sb-input" :disabled="sb_spinner"></b-form-input>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
    <hr class="sb-line">
    <b-row>
      <b-col cols="8">Tip, fees & taxes</b-col>
      <b-col class="orderdets-price">{{taxes_tips_fees | toCurrency}}</b-col>
    </b-row>
    <b-row v-if="order_subtotal>0" cols="1" class="orderdets-desc"><b-col><span v-if="order_type==1">Includes ${{defaultLocation.delivery_fee}} delivery fee</span></b-col></b-row>
    <hr class="sb-line">
    <b-row>
      <b-col cols="8"><b-form-input v-model="discountcode" size="sm" class="sb-input" :disabled="sb_spinner" placeholder="Got a discount code?"></b-form-input></b-col>
      <b-col v-if="discount_total==0"><b-button pill size="sm" variant="light" :disabled="sb_spinner" @click="checkDiscountCode()">Use it!</b-button></b-col>
      <b-col v-if="discount_total>0"><b-button pill size="sm" variant="light" :disabled="sb_spinner" @click="discount = []; discount_total = 0;">Clear</b-button></b-col>
    </b-row>
    <hr class="sb-line">
    <b-row>
      <b-col cols="5"><h5>Total</h5></b-col>
      <b-col cols="3" style="color:green;" v-if="discount_total > 0">(-{{discount_total | toCurrency}})</b-col>
      <b-col cols="3" v-else></b-col>
      <b-col cols="4" class="orderdets-price"><h5>{{order_total | toCurrency}}</h5></b-col>
    </b-row>
    <hr class="sb-line">
    <b-row class="mb-2">
      <b-col><b-form-input v-model="order_notes" size="sm" class="sb-input" :disabled="sb_spinner" placeholder="Order notes, etc."></b-form-input></b-col>
    </b-row>
    <div class="mt-2 sb-info">
      <b-alert v-model="orderlineAlert" variant="danger" class="sb-alert" dismissible>Please add some items!</b-alert>
      <b-alert v-model="orderTypeAlert" variant="danger" class="sb-alert" dismissible>Please select an Order Type!</b-alert>
      <b-button v-if="sb_spinner==false" class="mb-2" variant="light" id="submit" type="submit" @click="sb_spinner=true; validateform()">
        <span v-if="existOrder">UPDATE ORDER</span><span v-else>PLACE ORDER</span>
      </b-button>
      <b-button v-if="sb_spinner==true" class="mb-2" variant="light" disabled ><b-spinner small type="grow"></b-spinner>Wait...</b-button>

      <CustomerTipModal :order_total="order_total" @emit-post-tip="setTipFromModal"></CustomerTipModal>
      <StripePayment
        v-if="proceedStripePay"
        :pickupTime="pickupTime"
        :selectedMenuDate="selectedMenuDate"
        :defaultLocation="defaultLocation"
        :payment_intent="payment_intent"
        :order_type="order_type"
        :order_subtotal="order_subtotal"
        :order_total="order_total"
        @stop-stripe-pay="stopStripePay"
        @paymentstatus="afterSubmit"
        @sidebaroverlay="removeSBOverlay">
      </StripePayment>
      <StripeTerminal
        v-if="proceedStripeTerminal"
        :payment_intent="payment_intent"
        :orderlines="orderlines"
        :order_total="order_total"
        :tax_total="tax_total"
        :fees="fees"
        :customTip="customTip"
        :order_type="order_type"
        @payment-finish="endTerminalPayment"
        @switch-overlay="emitSwitchOverlay">
      </StripeTerminal>
      <CashCalculator
        v-if="proceedCashCalculator"
        :order_total="paymentTotal"
        @emit-close-modal="afterSubmit">
      </CashCalculator>
    </div>
    <b-modal
      id="mod-payment-type"
      title="Choose Payment Type"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      @hidden="emitSwitchOverlay(false)">
      <b-card-group deck style="column-count: 2;">
        <ChooseCard
          v-for="option of paymentoptions"
          v-bind:key="option.id"
          :option="option"
          :order_type="order_type"
          ChooseCard
          @emit-card-choice="payForOrder">
        </ChooseCard>
      </b-card-group>
      <b-row class="py-4" v-if="allowSplit"><b-col>
        <b-button
          block
          size="lg"
          variant="primary"
          @click="$bvModal.hide('mod-payment-type'); openSplitModal=true">
          Split Bill
        </b-button>
      </b-col></b-row>
    </b-modal>
    <SplitBill
      v-if="openSplitModal"
      :selectedOrderTotal="order_total"
      :splitPaidDetails="splitPaidDetails"
      @emit-split-payment="updateSplitPayments"
      @emit-close-split-modal="cleanCloseSplitModal"
      @emit-partially-paid="setPartiallyPaid"
    ></SplitBill>
  </div>
</template>

<script>
import StripePayment from '@/components/PlaceOrder/StripePayment.vue'
import StripeTerminal from '@/components/PlaceOrder/StripeTerminal.vue'
import OrderDetails from '@/components/PlaceOrder/OrderDetails.vue'
import ChooseCard from '@/components/PlaceOrder/ChooseCard.vue'
import CashCalculator from '@/components/PlaceOrder/CashCalculator.vue'
import SplitBill from '@/components/SplitBill.vue'
import CustomerTipModal from '@/components/PlaceOrder/CustomerTipModal.vue'

export default {
  name: 'Sidebar',
  components: {
    OrderDetails,
    StripePayment,
    StripeTerminal,
    ChooseCard,
    CashCalculator,
    SplitBill,
    CustomerTipModal
  },
  props: ['orderlines', 'vendor_id', 'defaultLocation', 'orderline_total', "selectedMenuDate", "order_type", "pickupTime", "custdets", "howtaken", "asap", "existOrder", "currentUser"],
  data () {
    return {
      proceedStripePay: false,
      proceedCashCalculator: false,
      proceedStripeTerminal: false,
      payment_intent: [],
      sb_spinner: false,
      tipoptions: [
        {text: 'None', value: 0},
        {text: '10%', value: 10},
        {text: '15%', value: 15},
        {text: '20%', value: 20},
        {text: 'Custom', value: -1}
      ],
      tip_select: 0,
      discountcode: '',
      discount: [],
      discount_total: 0,
      order_notes: '',
      orderlineAlert: false,
      minDelAlert: false,
      payment_type: 0,
      payoo_fee: 0.25,
      allowSplit: false,
      openSplitModal: false,
      splitPayment: {},
      splitPaidDetails: {},
      paymentTotal: 0.00,
      partiallyPaid: false,
      orderTypeAlert: false,
      customTip: 0,
      customTipVisible: false,
      customTipState: true,
      tipAlert: false,
    }
  },

  watch: {
    orderline_total: function() {
      // Upon change to the total, remove the minimum del alert, if appropriate
      if (this.minDelAlert==true && (this.defaultLocation.delivery_minimum<=this.orderline_total || this.order_type != 1)) {
        this.minDelAlert=false;
      }
      this.discount_total = 0;
      this.checkDiscountCode();
    },

    selectedMenuDate: function() {
      // this.retrievePickupTimes();
      this.$emit('emit-retrieve-pickup-times');
    },

// Keep payoo fee at 25c until either the order total goes over 10 or they pick to pay with card
    payment_type: function() {
      // If pay with card - set the fee to 50c, else leave it at 25c
      if ([2,3].includes(this.payment_type)) {
        this.payoo_fee = Number(0.50);
      } else {
        this.payoo_fee = Number(0.25);
      }
      if (this.payment_type!=2) {
        this.tip_total==0;
        this.tip_select=0;
      }
    },

    order_total: function() {
      if (this.order_total>Number(10)) {
        this.payoo_fee = Number(0.50);
      } else if (!([2,3].includes(this.payment_type))) {
        this.payoo_fee = Number(0.25);
      }
    },

    tip_select: function() {
      if ((this.tip_select==-1 && this.customTipVisible==false) || (this.tip_select != -1 && this.customTipVisible==true)) {
        this.$root.$emit('bv::toggle::collapse', 'custom-tip-collapse');
      }
    },

    customTip: function() {
      const tipstr = String(this.customTip)
      if (this.customTip<0 || (tipstr.includes('.')) && tipstr.split('.')[1].length>2) {
        this.customTipState = false;
      } else {
        this.customTipState = true;
      }
    },

  },

  computed: {
    orderid: function() {
        return (this.existOrder) ? this.existOrder.id : (this.payment_intent) ? this.payment_intent.order_id : 0
    },

    paymentoptions: function() {
      if (this.howtaken=='Phone') {
        return [
          { id: 2, name: 'Pay Now', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pay-by-card.png' },
          { id: 99, name: 'Pay Later', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pay-by-cash-card.png' }
        ]
      } else {
        return [
          { id: 1, name: 'Cash', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pay-by-cash.png' },
          { id: 3, name: 'Card', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pay-by-card.png' }
        ]
      }
    },

    order_subtotal: function() {
      return this.orderline_total - this.discount_total;
    },

    pi_id: function() {
      if (Object.keys(this.payment_intent).length > 0 && this.payment_intent.clientSecret) {
        var x = this.payment_intent.clientSecret.slice(3);
        var y = x.indexOf("_");
        return this.payment_intent.clientSecret.slice(0, (y+3));
      } else {
        return "";
      }
    },

    tax_total: function() {
      var taxes = 0;
      var taxrate = this.defaultLocation.tax_rate;
      taxes = this.order_subtotal * (Number(taxrate) / 100);
      // return taxes.toFixed(2);
      return Math.round((taxes + Number.EPSILON) * 100) / 100;
    },

    tip_total: function() {
      var tips = 0;
      if (this.tip_select!=-1) {
        tips = (Number(this.tip_select) / 100) * this.order_subtotal;
      } else {
        tips = Number(this.customTip);
      }
      // return tips.toFixed(2);
      return Math.round((tips + Number.EPSILON) * 100) / 100;
    },

    fees: function() {
      var fees = Number(0.00);
      fees += this.payoo_fee;
      if (this.order_type==1) {
        fees += this.defaultLocation.delivery_fee;
      }
      return fees;
    },

    taxes_tips_fees: function() {
      // Don't show 50c added if nothing has been added to order
      if (this.order_subtotal==0) {
        return 0;
      } else {
        const ttf = Number(this.tax_total) + Number(this.tip_total) + this.fees;
        return Math.round((ttf + Number.EPSILON) * 100) / 100;
      }
    },

    order_total: function() {
      var ordertotal = this.order_subtotal;
      // Don't show 50c added if nothing has been added to order
      if (ordertotal==0) {
        return 0;
      } else {
        ordertotal += this.taxes_tips_fees;
        ordertotal = Math.round((ordertotal + Number.EPSILON) * 100) / 100;
        return ordertotal;
      }
    },
  },

  methods: {
    // adjusttype = 'add' - Add duplicate item with all options preset
    // adjusttype = 'edit' - Remove one quantity (remember options) and re-add with new options
    // adjusttype = 'remove' - Remove one from the quantity, remove item if qty = 1
    emitAdjustOrderLine(orderline, adjustType) {
      this.$emit('emit-adjust-line', orderline, adjustType);
    },

    emitSwitchOverlay(overlay) {
      this.sb_spinner = false;
      this.$emit('switch-overlay', overlay);
    },

    async setTipFromModal(tip, enteredBool) {
      this.$emit('switch-overlay', true)
      this.$bvModal.hide('mod-payment-type')
      tip = (enteredBool==true) ? tip : 0;
      this.tip_select= await -1;
      this.customTip = await tip;
      await this.updateOrder();
      this.$bvModal.hide('cust-tip-modal')
      this.proceedStripeTerminal=true;
    },

    checkDiscountCode() {
      if (this.discountcode != '') {
        this.$api.get('vendor/'+this.vendor_id+'/discounts?code='+this.discountcode)
        .then(response => {
         this.discount = response.data;
         if (this.discount.discount_amount > 0) {
           this.discount_total = this.discount.discount_amount;
         }
         if (this.discount.discount_percent > 0) {
           this.discount_total = this.order_subtotal * (Number(this.discount.discount_percent/100));
         }
        })
        .catch(e => {
         console.log(e);
        })
      }
    },

    formatPickupTime() {
      this.pickupTime = (this.pickupTime == '') ? this.nextTimeSlot : this.pickupTime;
      // var today = moment().format('YYYY-MM-DD');
      return (this.asap==true) ? '' : this.selectedMenuDate + ' ' + this.pickupTime.slice(0,5);
    },

    // Prepare orderinfo for posting / patching
    prepOrderInfo() {
      var pickup_time = this.formatPickupTime();
      var orderlines = [];
      for (const line of this.orderlines) {
        const overridden_item_price = (line.allow_price_override && line.overridden_item_price) ? line.overridden_item_price : undefined
        orderlines.push(
          {
            "item_id": line.item_id,
            "quantity": line.qty,
            "notes": line.notes,
            "overridden_item_price": overridden_item_price,
            "options": line.choicearray
          }
        )
      }
      const phone = this.custdets.cust_phone ? "1" + this.custdets.cust_phone : undefined;
      const customtip = this.tip_select==-1 ? Number(this.tip_total) : 0

      var data = {
        "payoo_public_secret": process.env.VUE_APP_PAYOO_PUBLIC_SECRET,
        "cust_name": this.custdets.cust_name,
        "cust_phone": phone,
        "cust_email": this.custdets.cust_email,
        "cust_addr": this.custdets.cust_addr,
        "order_type": Number(this.order_type),
        "table_number": this.custdets.tablenum,
        "discount_code": this.discountcode,
        "tip": Number(this.tip_select),
        "custom_tip": customtip,
        "order_notes": this.order_notes,
        "how_taken": this.howtaken,
        "payment_type": this.payment_type,
        "orderlines": orderlines,
        "staff_member": this.currentUser
      };
      if (pickup_time != '') {
        data['pickup_time'] = pickup_time
      }

      // if it's a pay later, then set the status to submitted until it's paid
      if (this.payment_type==99) {
        data['order_status']=3;
      } else if (this.payment_type==1) {
        // if it's cash order - set to paid straight away
        data['order_status']=6;
      }

      return data;
    },

    errorCreateUpdatePIModal() {
      // display error modal message if issue with creating /updating payment intent and / or Payoo order
      this.$bvModal.msgBoxOk("We're sorry, there was a problem taking your order.", {
        title: 'Error sending order',
        centered: true
      })
      this.emitSwitchOverlay(false);
    },

    /*
    Loads the payment intent key for the user to pay.
    */
    async createOrder() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // Go get the data
      var data = this.prepOrderInfo();
      if (Object.keys(this.splitPayment).length>0) {
        data['split_payment_amount'] = this.splitPayment.Amount;
      }
       // create order with status of 'open' and payment intent with stripe
      await this.$api.post('/locations/'+this.defaultLocation.id+'/orders', data, config)
        .then( function( response ){
          if (response.data.created == true) {
            // If it's a split payment
            if (Object.keys(this.splitPayment).length>0) {
              // set splitPaidDetails for use in Modal
              this.$set(this.splitPaidDetails, 'Line', this.splitPayment.Line)
              this.$set(this.splitPaidDetails, 'Amount', this.splitPayment.Amount)
              this.paymentTotal = this.splitPayment.Amount;
              this.showoverlay = false;
            }
            // log order details and secret (payment intent populated with order id even if not a Stripe order)
            this.payment_intent = response.data;
            // this.orderid = this.payment_intent.order_id;
            this.takePayment();
          } else if (response.data.invaliditem==true) {
            this.$bvModal.msgBoxOk('The order contains an item - '+response.data.item+', which is not available on the selected day or is out of stock. Please choose something else from our menu and resubmit', {
              title: 'Selected item unavailable',
              centered: true
            })
            this.emitSwitchOverlay(false);
          }
        }.bind(this))
        .catch(e => {
         console.log(e);
         this.errorCreateUpdatePIModal();
        })
    },

    /*
    Updates an existing payment intent for the user to pay.
    */
    async updateOrder() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var data = this.prepOrderInfo();
      if (Object.keys(this.splitPayment).length>0) {
        data['split_payment_amount'] = this.splitPayment.Amount;
      }
      data["payment_intent_id"]=this.pi_id;
       // create order with status of 'open' and payment intent with stripe
      await this.$api.patch('/locations/'+this.defaultLocation.id+'/orders/'+this.orderid, data, config)
        .then( function( response ){
          // STANDARDIZE THIS TO BE SUCCESS ONLY!!!!!!
          if (response.data.success == true || response.data.created == true) {
            // If it's a split payment
            if (Object.keys(this.splitPayment).length>0) {
              // set splitPaidDetails for use in Modal
              this.$set(this.splitPaidDetails, 'Line', this.splitPayment.Line)
              this.$set(this.splitPaidDetails, 'Amount', this.splitPayment.Amount)
              this.paymentTotal = this.splitPayment.Amount;
              this.showoverlay = false;
            }
            // log order details and secret
            this.payment_intent = response.data;
            // this.orderid = this.payment_intent.order_id;
            this.takePayment();
          } else if (response.data.invaliditem==true) {
            this.$bvModal.msgBoxOk('The order contains an item - '+response.data.item+', which is not available on the selected day or is out of stock. Please choose something else from our menu and resubmit', {
              title: 'Selected item unavailable',
              centered: true
            })
            this.emitSwitchOverlay(false);
          }
        }.bind(this))
        .catch(e => {
         console.log(e);
         this.errorCreateUpdatePIModal();
        })
    },

    takePayment() {
      this.emitSwitchOverlay(false);
      // If it's a Stripe remote payment, pop the stripe payments window
      if (this.payment_type==2) {
        this.proceedStripePay=true;
      } else if (this.payment_type==3) {
        // It's a Stripe Terminal payment - pop the Tip modal if it's not a table order
        if (this.order_type!=4) {
          this.$bvModal.show('cust-tip-modal')
        } else {
          this.proceedStripeTerminal=true
        }
      } else if (this.payment_type==1) {
        // pop calculator modal
        this.proceedCashCalculator=true;
      } else {
        // It's a Cash / Pay Later order - leave the order as "Submitted" and reset the order page
        this.afterSubmit();
      }
    },

    endTerminalPayment(complete) {
      this.proceedStripeTerminal = false;
      this.$bvModal.hide('stripe-terminal');
      if (complete==true) {
        this.afterSubmit();
      }
    },

    afterSubmit(pickupTime) {
      // set CashCalculator to false in case the calc modal was closed
      this.proceedCashCalculator=false;
      this.$bvModal.hide('mod-payment-type');
      if (!this.partiallyPaid) {
        this.$emit('emit-payment-succeeded', this.payment_intent, pickupTime, this.order_type, this.defaultLocation.delivery_time, 'test');
      }
    },

    removeSBOverlay(overlay) {
      this.sb_spinner=overlay;
    },

    stopStripePay() {
      this.proceedStripePay = false;
    },

    // validates the form has required elements prior to loading the payment intent
    async validateform() {
      var validData = true;

      // Check there are order lines
      if (this.orderlines.length == 0) {
        validData=false;
        this.orderlineAlert = true;
        this.sb_spinner = false;
      }

      // Check subtotal > minimum delivery amount if delivery
      if (this.order_type=='1' && this.orderline_total < this.defaultLocation.delivery_minimum) {
        validData=false;
        this.minDelAlert = true;
        this.sb_spinner = false;
      }

      // CHECK HOW TAKEN / ORDER TYPE
      if (typeof this.order_type == "undefined" || this.howtaken == "None") {
        validData=false;
        this.orderTypeAlert = true;
        this.sb_spinner = false;
      }

      if (this.order_type != 4 && !this.custdets.cust_name) {
        validData=false;
        this.sb_spinner = false;
        this.$emit('emit-cust-name-alert', true);
      }


      if (validData==true) {
        if (this.order_type==4 || this.existOrder) {
          this.payForOrder(99);
        } else {
          if (this.howtaken=='Counter') {
            // set allow split payments
            this.allowSplit=true;
          }
          // turn off spinner, set paymentTotal as order_total and open Payment Modal
          this.sb_spinner = false;
          this.paymentTotal = this.order_total;
          this.$bvModal.show("mod-payment-type");
        }
      }
    },

    async payForOrder(paytype) {
      this.emitSwitchOverlay(true);
      this.payment_type=paytype;
      // if it's an existing order, assign the existing order id to the payment intent order id
      this.order_id = (this.existOrder) ? this.existOrder.id : this.orderid;
      // decide if we create a new payment intent or update an existing one
      if (this.order_id) {
        this.updateOrder();
      } else {
        this.createOrder();
      }
    },

    // Split Billing Methods
    setPartiallyPaid(pp) {
      this.partiallyPaid = pp;
      if (!this.partiallyPaid) {
        this.$bvModal.hide('mod-split-bill');
      }
    },

    updateSplitPayments(splitpayments) {
      this.allowSplit=false;
      this.splitPaidDetails={};
      this.splitPayment = splitpayments;
    },

    cleanCloseSplitModal() {
      this.openSplitModal = false;
    },
  },
}
</script>

<style>
  @import '../../styles/style.css';
</style>
